import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionInterceptor implements HttpInterceptor {
  private oidcService = inject(OidcSecurityService);
  private apiUrl = environment.api;
  private adminApiUrl = environment.adminApi;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf(this.apiUrl) > -1 || request.url.indexOf(this.adminApiUrl) > -1) {
      return this.addSessionHeader(request, next);
    }
    return next.handle(request);
  }

  private addSessionHeader(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.oidcService.getState().pipe(
      switchMap((sessionState: string) => {
        if (sessionState) {
          const headerSettings: {[name: string]: string | string[];} = {};
          for (const key of request.headers.keys()) {
            headerSettings[key] = request.headers.getAll(key);
          }

          headerSettings['x-session-id'] = sessionState;

          const newHeader = new HttpHeaders(headerSettings);
          const changedRequest = request.clone({headers: newHeader});
          return next.handle(changedRequest);
        }

        return next.handle(request);
      })
    );
  }
}
